// extracted by mini-css-extract-plugin
export default {"page":"cart_page__rnnwL","page__title":"cart_page__title__BNvT9","page__info":"cart_page__info__ZCRIw"};